/**
 * リクエストパラメータを生成する
 * @param {Object | undefined} request リクエストオブジェクト
 * @returns {string} リクエストパラメータ
 */
export const createQueryParameters = (request: Object | undefined): string => {
  let queryParam = "";
  if (request === undefined) {
    return queryParam;
  }
  for (const [key, value] of Object.entries(request)) {
    if (key === "timestamp") continue;
    if (value) queryParam += `${key}=${encodeURIComponent(value)}&`;
  }
  queryParam = queryParam.substring(0, queryParam.length - 1);
  return queryParam;
};
